import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ModalBuilder, Form, notifySuccess, Format } from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { getPartUpgrade, requestPartUpgrade } from ".";
import { UnitTable, ProductTable } from "./Components";
import { Grid, GridColumn, GridRow } from "semantic-ui-react";

import { Actions, Targets } from "constants/permissions";
import { PermissionCheck } from "features/../../../shared/components/auth";

const PartUpgrade = ({ as: As, scheduleId, disabled, creditAvailable }) => {
  const { t } = useTranslation("agreements", { keyPrefix: "ScheduleRow" });
  const { t: tps } = useTranslation("agreements", {
    keyPrefix: "ScheduleRow.PartUpgrade",
  });

  const dispatch = useDispatch();

  return (
    <PermissionCheck action={Actions.SubmitRequest} target={Targets.Schedules}>
      <PermissionCheck action={Actions.View} target={Targets.Schedules}>
        <ModalBuilder
          renderTrigger={(showModal) => (
            <As onClick={showModal} disabled={disabled}>
              {t("Actions.Part_Upgrade")}
            </As>
          )}
          withForm
          loadAction={getPartUpgrade}
          loadParams={scheduleId}
          submitAction={requestPartUpgrade}
          submitParams={scheduleId}
          onSubmitted={() => {
            dispatch(notifySuccess(t("Actions.Submitted_Successfully")));
          }}
          renderModal={(modalProps, formProps) => {
            return (
              <TranslatedModal.Edit
                className="large-modal upgrade-request-modal"
                header={tps("Header")}
                submitLabel={tps("Submit_Request")}
                submitDisabled={
                  (process.env.TRADE_AS_IPS
                    ? !formProps.value.applicableFromPrevious
                    : true) && !formProps.value.applicableFromNext
                }
                {...modalProps}
              >
                <Form {...formProps}>
                  {(fields) => (
                    <React.Fragment>
                      <Grid className="upgrade-types">
                        {process.env.TRADE_AS_IPS && (
                          <GridRow>
                            <GridColumn width={1} className="right-align">
                              <Form.Checkbox
                                field="applicableFromPrevious"
                                checked={formProps.value.applicableFromPrevious}
                                fluid
                              />
                            </GridColumn>
                            <GridColumn width={15}>
                              <label>{tps("applicable_from_previous")}</label>
                            </GridColumn>
                          </GridRow>
                        )}
                        <GridRow>
                          <GridColumn width={1} className="right-align">
                            <Form.Checkbox
                              field="applicableFromNext"
                              checked={formProps.value.applicableFromNext}
                              fluid
                            />
                          </GridColumn>
                          <GridColumn width={10}>
                            <label>{tps("applicable_from_next")} </label>
                          </GridColumn>
                          <GridColumn
                            width={5}
                            className="red-highlight credit-available"
                          >
                            <span className="credit-available-label">
                              {tps("Credit_Available")}
                            </span>
                            <Format.Number
                              decimalPlaces={2}
                              thousandSeparator
                              format={process.env.CURRENCY_CODE}
                              value={creditAvailable || 0}
                            />
                          </GridColumn>
                        </GridRow>
                      </Grid>

                      <div className="unit-table">
                        <div className="vertical-scrollbar large">
                          <UnitTable formProps={formProps} />
                        </div>
                      </div>
                      <div className="retain-container">
                        <Form.RadioGroup
                          className="retain"
                          field="retain"
                          label={tps("Retain_Products")}
                          options={[
                            { value: true, text: tps("Yes") },
                            { value: false, text: tps("No") },
                          ]}
                        />
                      </div>

                      <div className="vertical-scrollbar large">
                        <ProductTable
                          formProps={formProps}
                          showUpgrade={true}
                          showRetainProduct={fields.retain}
                        />
                      </div>
                      <br />
                      <br />
                      <Form.TextArea
                        field="comments"
                        label={t("Additional_Comments")}
                        fluid
                        placeholder={t("Additional_Comments_Placeholder")}
                      />
                    </React.Fragment>
                  )}
                </Form>
              </TranslatedModal.Edit>
            );
          }}
        />
      </PermissionCheck>
    </PermissionCheck>
  );
};

export default PartUpgrade;
